import React, { useState } from "react";
import { EyeIcon, EyeSlashIcon } from "@phosphor-icons/react";
import {
  IconButton,
  Input,
  InputGroup,
  InputProps,
  InputRightElement,
  useColorModeValue,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

interface CustomInputProps {
  placeholder?: string;
  type?: string;
  value?: string;
  name?: string;
  error: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

/**
 * CustomInput - A styled input field that:
 * - Removes Chakra's blue border and focus glow
 * - Supports placeholder, type, and default values
 */
const CustomInput: React.FC<CustomInputProps & InputProps> = ({
  placeholder = "",
  type = "text",
  value = "",
  name,
  error,
  onChange,
  ...props
}) => {
  const [show, setShow] = useState(false);
  const isPassword = type === "password";
  const { t } = useTranslation();

  const iconColor = useColorModeValue("gray.600", "gray.300");

  return (
    <InputGroup>
      <Input
        name={name}
        placeholder={placeholder}
        type={isPassword ? (show ? "text" : "password") : type}
        value={value}
        fontSize="16px"
        fontFamily="Work Sans"
        borderRadius="4px"
        onChange={onChange}
        // borderColor="gray.300"
        // inputMode="none"
        _focus={{
          borderWidth: 2,
          borderColor: error ? "red.500" : "primary.500",
          boxShadow: "none",
        }}
        {...props}
        bg={useColorModeValue("white", "gray.800")}
        color={useColorModeValue("gray.800", "gray.100")}
      />
      {isPassword && (
        <InputRightElement>
          <IconButton
            aria-label={String(t("common.togglePasswordVisibility"))}
            icon={show ? <EyeSlashIcon size={16} /> : <EyeIcon size={16} />}
            variant="ghost"
            size="sm"
            color={iconColor}
            onClick={() => setShow(!show)}
          />
        </InputRightElement>
      )}
    </InputGroup>
  );
};

export default CustomInput;
